import { Theme } from '@mui/material';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { makeStyles, withStyles } from 'tss-react/mui';
import C from '../../../assets/styles/UtilsCSS';

const getResponsiveLabelStyles = (theme: Theme) => ({
  [C.r(theme, C.XXS, C.XXX)]: { '& .MuiTreeItem-label': { fontSize: '1em' } },
  [C.r(theme, C.XS, C.XSX)]: { '& .MuiTreeItem-label': { fontSize: '1.1em' } },
  [C.r(theme, C.SM, C.SMX)]: { '& .MuiTreeItem-label': { fontSize: '1.2em' } },
  [C.r(theme, C.MD, C.MDX)]: { '& .MuiTreeItem-label': { fontSize: '1.3em' } },
  [C.r(theme, C.LG, C.LGX)]: { '& .MuiTreeItem-label': { fontSize: '1.3em' } },
  [C.r(theme, C.XL, C.XLX)]: { '& .MuiTreeItem-label': { fontSize: '1.4em' } },
  [C.r(theme, C.XXL, C.YLX)]: { '& .MuiTreeItem-label': { fontSize: '1.4em' } },
  [C.IPAD_10]: { '& .MuiTreeItem-label': { fontSize: '1em', paddingTop: 3 } },
  [C.SAMSUNG]: { '& .MuiTreeItem-label': { fontSize: '1em', paddingTop: 3 } },
});

const selectedStyles = {
  color: '#171b3d',
  borderRadius: 4,
  backgroundColor: '#f6f6f6 !important',
};

const expandedIconStyles = {
  '.MuiTreeItem-iconContainer': {
    color: '#d30535',
  },
};

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: '100%',
    color: '#fff',
    bottom: 0,
    padding: 0,
    left: 0,
    '&.Mui-selected': selectedStyles,
    '&.Mui-expanded': expandedIconStyles,
    ...getResponsiveLabelStyles(theme),
  },
  subroot: {
    width: 'auto',
    color: '#fff',
    left: 0,
    '&.Mui-selected': {
      ...selectedStyles,
      marginLeft: 10,
      '& .MuiTreeItem-label': {
        paddingLeft: 0,
      },
    },
    '&.Mui-expanded': expandedIconStyles,
    ...getResponsiveLabelStyles(theme),
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
  },
  labelIcon: {
    height: 35,
    width: 25,
  },
  labelText: {
    height: 35,
    flexGrow: 1,
    fontSize: '1em',
    display: 'flex',
    alignItems: 'center',
  },
}));

export const StyledTreeItem = withStyles(TreeItem, (theme): any => ({
  content: {
    flexDirection: 'row-reverse',
    height: '40px',
  },
  label: {
    paddingLeft: 12,
    fontSize: '1em',
  },
  iconContainer: {
    transform: 'scale(2)',
    marginRight: 8,
  },
  [C.r(theme, C.XXS, C.XXX)]: { content: { height: '30px' } },
  [C.r(theme, C.XS, C.XSX)]: { content: { height: '30px' } },
  [C.r(theme, C.SM, C.SMX)]: { content: { height: '35px' } },
  [C.r(theme, C.MD, C.MDX)]: { content: { height: '40px' } },
  [C.r(theme, C.LG, C.LGX)]: { content: { height: '43px' } },
  [C.r(theme, C.XL, C.XLX)]: { content: { height: '50px' } },
  [C.r(theme, C.XXL, C.YLX)]: { content: { height: '55px' } },
  [C.IPAD_10]: { content: { height: '27px' } },
  [C.SAMSUNG]: { content: { height: '27px' } },
}));
